import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { PaymentAPI } from '../../../api/PaymentAPI.js';
import { loadStripe } from '@stripe/stripe-js';
import Loader from '../../../component/Loader.jsx';
import { Elements } from '@stripe/react-stripe-js';
import styles from '../../../styles/modules/EventCheckout.module.css';
import EventPayment from './EventPayment.jsx';

const EventCheckout = () => {
    const { userInfo, selectedClub } = useSelector((store) => store.user);
    const [stripePromise, setStripePromise] = useState(null);
    const [defaultCard, setDefaultCard] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { state } = useLocation();
    const navigate = useNavigate();

    const getDefaultCard = async () => {
        try {
            setIsLoading(true);
            const defaultPaymentMethod = await PaymentAPI.fetchDefaultPaymentMethodData(userInfo?.userId, selectedClub?.clubId);
            setDefaultCard(defaultPaymentMethod.Data);
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    }
    const getStripeDetails = async () => {
        try {
            setIsLoading(true)
            const [publishKey, connectedId] = await Promise.allSettled([
                PaymentAPI.getPublishKey(),
                PaymentAPI.getAdminConnectedAccountId({ userId: userInfo?.userId, clubId: selectedClub?.clubId })
            ])
            setStripePromise(loadStripe(publishKey.value.Data, { stripeAccount: connectedId.value.Data }));
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }

    }
    useEffect(() => {
        if (userInfo.userId && selectedClub?.clubId) {
            getStripeDetails();
            getDefaultCard();
        }
    }, [userInfo.userId, selectedClub?.clubId]);
    const appearance = {
        theme: 'flat',
        rules: {
            '.Input': {
                border: '1px solid rgba(156, 150, 150, 0.358)',
                boxShadow: 'none',
            },
            '.Input:focus': {
                border: '1px solid #8fbd04',
                boxShadow: 'none',
            },
            '.Input--invalid': {
                borderColor: '#df1b41',
            },
            '.Tab': {
                padding: '10px 15px',
                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1),0 4px 6px -2px rgba(0, 0, 0, 0.05)'
            },
            '.Tab--selected': {
                backgroundColor: '#8fbd04',
                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1),0 4px 6px -2px rgba(0, 0, 0, 0.05)'
            },
            '.Tab--selected:focus': {
                "outline": '2px solid #8fbd04',
                "boxShadow": 'none'
            },
            '.TabLabel': {
                color: '#30313d',
            },
            '.Label': {
                fontWeight: '500',
            },
        },
    };
    const options = {
        clientSecret: state?.clientSecret,
        appearance,
    };
    if (!state) {
        navigate('/')
    }
    return (
        <div className={styles['seaason_checkout_page']}>
            {isLoading && <Loader />}
            {state?.clientSecret && stripePromise && (
                <Elements stripe={stripePromise} options={options}>
                    <EventPayment
                        isLoading={isLoading}
                        setIsLoading={setIsLoading}
                        defaultCard={defaultCard}
                        paymentIntentId={state?.paymentIntentId}
                        feeDetails={state?.feeDetails}
                        replaceablePlan={state?.replaceablePlan}
                        processingFee={state?.processingFee}
                        totalAmount={state?.totalAmount}
                    />
                </Elements>
            )}
        </div>
    )
}

export default EventCheckout